// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4609":"0c4d62cfe6f28c7d","5302":"ba40ee2fd77534e2","8160":"c49947a813602b17"}[chunkId] + ".js";
};